import { ref } from "vue";
import { defineStore } from "pinia";
import { useCoins } from "@/composables/useCoins";

export const useWithdrawStore = defineStore("withdraw", () => {
  // WITHDRAW

  const form = ref({
    coin: null,
    network: null,
    amount: null,
    address: "",
  });

  const instantLinkPayload = ref(null);

  const setInstantLinkPayload = (payload) => {
    instantLinkPayload.value = payload;
  };

  const getInstantLinkPayload = () => {
    return instantLinkPayload.value;
  };

  const setForm = (coin, network) => {
    const coins = useCoins().coins.value;
    const coinObj = coins.find((a) => a.config.id === coin);
    if (coinObj) {
      form.value.coin = coinObj;
      form.value.network = coinObj.config.networks.find(
        (a) => a.network_id === network,
      );
    }
  };

  const currentFee = ref({
    fee: 0,
  });
  const setFee = (data) => {
    currentFee.value = data;
  };

  const formClear = () => {
    form.value.amount = null;
    form.value.address = "";
    currentFee.value.fee = 0;
    isBalanceAvailable.value = false;
  };

  const isBalanceAvailable = ref(false);
  const setBalanceAvailable = (value) => {
    isBalanceAvailable.value = value;
  };

  return {
    form,
    setForm,
    formClear,
    currentFee,
    setFee,
    isBalanceAvailable,
    setBalanceAvailable,
    setInstantLinkPayload,
    getInstantLinkPayload,
  };
});
